module.exports = __webpack_public_path__ + "static/media/wave-6.e1fad8d9.png";